<template>
  <section class="nav_path_section">
    <img src="https://hr-crm.io/assets/img/office/1.png" alt="">
    <div>
      <router-link to="/" class="path_home"><house-svg/></router-link>
      <fragment v-for="(path,i) in pathName.data" :key="pathName.to">
        <path-arrow/>
        <router-link  :to="pathName.to" :class="['path_name_link', {'black': i + 1 === pathName.data.length}]">{{path}}</router-link>
      </fragment>

    </div>
  </section>
</template>


<script>
import HouseSvg from "./svg/house-svg.vue";
import PathArrow from "./svg/path-arrow.vue";

export default {
  name: "nav-path",
  components: {PathArrow, HouseSvg},
  computed: {
    currentRoutePatch() {
      return this.$route.fullPath;
    },
    pathName() {
      const data = [];
      if(this.currentRoutePatch.startsWith('/archive')) {
        data.push('Закрытые вакансии')
      } else if(this.currentRoutePatch.startsWith('/messages')) {
        data.push('Сообщения')
      } else if(this.currentRoutePatch.startsWith('/calendar')) {
        data.push('Календарь')
      }else if(this.currentRoutePatch.startsWith('/analytics')) {
        data.push('Аналитика')
      } else if(this.currentRoutePatch.startsWith('/support')) {
        data.push('Техподдержка')
      } else if(this.currentRoutePatch.startsWith('/settings')) {
        data.push('Настройки')
        if(this.currentRoutePatch.includes('/profile')) {
          data.push('Профиль пользователя')
        } else if(this.currentRoutePatch.includes('/subscribe')) {
          data.push('Подписка')
        } else if(this.currentRoutePatch.includes('/interaction')) {
          data.push('Взаимодействие с кандидатом')
        } else if(this.currentRoutePatch.includes('/apps')) {
          data.push('Интеграции')
        } else if(this.currentRoutePatch.includes('/notifications')) {
          data.push('Каналы уведомлений')
        } else if(this.currentRoutePatch.includes('/chrome-ext-btn')) {
          data.push('Кнопка сохранения кандидатов')
        } else if(this.currentRoutePatch.includes('/questionnaire')) {
          data.push('Анкеты для кандидатов')
        } else if(this.currentRoutePatch.includes('/messages')) {
          data.push('Шаблоны писем и сообщений')
        } else if(this.currentRoutePatch.includes('/voice-messages')) {
          data.push('Техподдержка')
        } else if(this.currentRoutePatch.includes('/Голосовые сообщения')) {
          data.push('Техподдержка')
        } else if(this.currentRoutePatch.includes('/users')) {
          data.push('Добавленные в систему пользователи')
        }
      }
      else if(this.currentRoutePatch.startsWith('/tasks')) {
        data.push('Рабочие задачи')
      }

      return {data, to: this.currentRoutePatch};
    }
  }
}
</script>

<style>
#nav-collapse > .nav_path_section {display: flex; align-items: center;}
#nav-collapse > .nav_path_section > img {margin-right: 12px; max-height: 27px; visibility: hidden;}
#nav-collapse > .nav_path_section > div {margin-left: 12px; display: flex; align-items: center;}
#nav-collapse > .nav_path_section > div > a.router-link-exact-active > svg > path {fill: #FFFFFF;}
#nav-collapse > .nav_path_section > div > a.router-link-exact-active {border: 1px solid #2F2F32;}
#nav-collapse > .nav_path_section > div > a {border-radius: 4px; border: 1px solid transparent}
 #nav-collapse > .nav_path_section > div > a.path_name_link.black {background: #2F2F32}
#nav-collapse > .nav_path_section > div > a.path_name_link {padding: 2px 16px; font-size: 14px; color: #868C95; text-decoration: none;}
#nav-collapse > .nav_path_section > div > .path_arrow {margin-top: 3px;}
#nav-collapse > .nav_path_section > div > a.path_home {padding: 4px 6px 4px 7px;}
#nav-collapse > .nav_path_section > div > a:not(.router-link-exact-active):hover {background: rgba(37, 145, 203, 0.20);}
#nav-collapse > .nav_path_section > div > a:hover > svg > path {fill: #FFFFFF}
#nav-collapse > .nav_path_section > div > a:not(:last-child) {margin-right: 8px;}

@media (max-width: 992px) {
  #nav-collapse > .nav_path_section {display: none;}
}


</style>
